import styled from 'styled-components';
export const DropDownGoBackButtonWrapper = styled.div `
  display: flex;
  flex-direction: row;
  gap: 4px;
  padding: 8px 16px;
`;
export const DropdownItemStyled = styled.div `
  ${({ selected }) => `padding 4px ${selected ? '15px' : '16px'};`}
  ${({ selected, theme }) => selected &&
    `
      color: ${theme.colors.gray100};
      background-color: ${theme.colors.blue500};
  `}
`;
export const DropdownItemContainerStyled = styled.div `
  display: flex;
  flex-direction: column;
  width: auto;
  padding: 11.5px 0px 17.5px 0px;
  border-radius: 8px;
  gap: 8px;
  background: ${({ theme }) => theme.colors.gray100}};
  box-shadow: 4px 4px 20px 0px rgba(111, 140, 176, 0.41), -6px -6px 20px 0px #FFF, 2px 2px 4px 0px rgba(114, 142, 171, 0.10);
  overflow: scroll;
`;
export const DropdownItemWrapperStyled = styled.div `
  position: absolute;
  z-index: 10;
  top: 59px;
  width: calc(100% - 56px);
  transform-origin: top;
  ${({ open }) => open ? 'transform: scaleY(1);  max-height: 186px;' : 'transform: scaleY(0);  max-height: 0px;'}
  transition-duration: 0.5s;
  button:nth-last-child(-n + 1) {
    border-radius: 0px 0px 4px 4px;
  }
  display: flex;
  justify-content: center;
`;
//# sourceMappingURL=styled.js.map